import { Ticket, Sparkle } from "lucide-react";

const MAP = {
  "Now Playing": {
    cls: "bg-[#E6F4ED] text-[#0D382B] border-[#B2E2CB] dark:bg-[#0B2D22] dark:text-[#52E0AC] dark:border-[#155440]",
    dot: "bg-[#0D382B] dark:bg-[#52E0AC]",
  },
  "Coming Soon": {
    cls: "bg-[#EBF8FF] text-[#1A365D] border-[#BEE3F8] dark:bg-[#0D253F] dark:text-[#63B3ED] dark:border-[#1A4971]",
    dot: "bg-[#1A365D] dark:bg-[#63B3ED]",
  },
  "Closing Soon": {
    cls: "bg-[#FFF3E0] text-[#7A3608] border-[#FFE0B2] dark:bg-[#3B1A05] dark:text-[#FF9D54] dark:border-[#6B310A]",
    dot: "bg-[#7A3608] dark:bg-[#FF9D54]",
  },
  Closed: {
    cls: "bg-stone-200 text-stone-600 border-stone-300 dark:bg-stone-800 dark:text-stone-400 dark:border-stone-700",
    dot: "bg-stone-500",
  },
};

export function StatusBadge({ status, testId }) {
  const s = MAP[status] || MAP["Now Playing"];
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold tracking-wide ${s.cls}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {status}
    </span>
  );
}

export { Ticket, Sparkle };
